<template>
  <v-card class="d-flex align-start px-2 py-4" :to="{ name: 'Person', params: { id } }" elevation="0" tile>
    <v-img :src="cover_image" max-width="80px" contain v-if="cover_image !== ''"></v-img>
    <v-img src="@/assets/person-placeholder.png" max-width="80px" contain v-else></v-img>
    <div class="ml-2">
      <span>{{ name_en }}</span>
      <span v-if="name_zh !== ''"> ({{ name_zh }})</span>
      <span class="d-flex text-body-2">{{ service_organization }}</span>
      <span class="d-flex text-body-2">{{ service_title }}</span>
    </div>
  </v-card>
</template>

<script>
export default {
  name: "PersonCard",
  props: {
    id: {
      type: Number,
      required: true
    },
    cover_image: {
      type: String
    },
    name_en: {
      type: String
    },
    name_zh: {
      type: String
    },
    service_organization: {
      type: String
    },
    service_title: {
      type: String
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/scss/variables.scss";

.v-application .text-body-2 {
  font-family: $body-font-family;
}
</style>
